import { IS_SERVER } from '@af-app/config';

export default class AnimFrameHandler {
	private processStack:Array<Function> = [];
	private kill:boolean = false;

	public addProcess(process:Function, index:number = -1) {
		if(index >= 0) {
			this.processStack[index] = process;
		} else{
			this.processStack.push(process);
		}
	}

	public execute() {
		this.kill = false;
		let animFrame = IS_SERVER ? (func:Function) => func() : (func:FrameRequestCallback) => window.requestAnimationFrame(func);

		let processStack = this.processStack;
		animFrame(() => {
			for (let i = 0; i < processStack.length; i++) {
				if(this.kill) return;
				try {
					processStack[i]();
				} catch(e) {
					if(!this.kill) throw e;
					return;
				}
			}
		});
		this.processStack = [];
	}

	public flush() {
		this.kill = true;
		this.processStack = [];
	}
}